import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";

const rootElement = document.getElementById("frontpage-hero-app");
document.addEventListener("DOMContentLoaded", (e) => {
  if (!rootElement) {
    return;
  }

  const root = createRoot(rootElement);

  // Load react app only after DOM content is loaded
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
